import { render, staticRenderFns } from "./StorefrontIntegrationSystemConfigCards.vue?vue&type=template&id=478fe60e"
import script from "./StorefrontIntegrationSystemConfigCards.vue?vue&type=script&lang=js"
export * from "./StorefrontIntegrationSystemConfigCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports